export const qs = (s) => document.querySelector(s)



// WEBPACK FOOTER //
// ./helpers.js